// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getAuth, signOut,signInWithPopup,GoogleAuthProvider,setPersistence,browserLocalPersistence} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBlBhbfuTiXpxNK-GsvMVq__2FrQW_tXEY",
  authDomain: "weather-e9ff5.firebaseapp.com",
  projectId: "weather-e9ff5",
  storageBucket: "weather-e9ff5.appspot.com",
  messagingSenderId: "275779757093",
  appId: "1:275779757093:web:0e305f20d129ce91624bcc",
  measurementId: "G-K8K9YLQNXE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const googleAuthProvider = new GoogleAuthProvider();

export  {auth,signInWithPopup,googleAuthProvider,analytics,signOut,setPersistence,browserLocalPersistence};